module.exports = __webpack_public_path__ + "img/intro_sub_uk.c1844bba.svg";